import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { configuredOriginRedirect } from "./lib/publicOrigin";
import "./styles.css";

const configuredPublicOrigin = (import.meta.env.VITE_PUBLIC_ORIGIN as string | undefined)?.replace(/\/$/, "") ?? "";
const configuredRedirect = configuredOriginRedirect(window.location.href, configuredPublicOrigin, import.meta.env.PROD);

if (configuredRedirect) {
  window.location.replace(configuredRedirect);
}

const homeMetadata = { title: "Protein & Fiber Guard — Two goals, one simple fix", description: "Snap a meal, protect your protein and fiber guardrails, and get one practical food fix." };
const publicMetadata: Record<string, { title: string; description: string }> = {
  "/": homeMetadata,
  "/pricing": { title: "Pricing — Protein & Fiber Guard", description: "Start with one free meal check each day, then choose unlimited monthly or annual access." },
  "/privacy": { title: "Privacy — Protein & Fiber Guard", description: "How Protein & Fiber Guard handles account, meal, plan, and AI-processing data." },
  "/terms": { title: "Terms — Protein & Fiber Guard", description: "Account, subscription, cancellation, refund, and general wellness terms for Protein & Fiber Guard." }
};
const metadata = publicMetadata[window.location.pathname] ?? homeMetadata;
const canonicalOrigin = configuredPublicOrigin || "https://proteinfiberguard.com";
const canonicalUrl = `${canonicalOrigin}${window.location.pathname === "/" ? "/" : window.location.pathname}`;
document.title = metadata.title;
document.querySelector('meta[name="description"]')?.setAttribute("content", metadata.description);
document.querySelector('meta[property="og:title"]')?.setAttribute("content", metadata.title);
document.querySelector('meta[property="og:description"]')?.setAttribute("content", metadata.description);
document.querySelector('meta[property="og:url"]')?.setAttribute("content", canonicalUrl);
document.querySelector('link[rel="canonical"]')?.setAttribute("href", canonicalUrl);

if (!configuredRedirect) {
  createRoot(document.getElementById("root")!).render(<StrictMode><App /></StrictMode>);
}

if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => navigator.serviceWorker.register("/sw.js").catch(() => undefined));
}
